export default {
  path: '/print-fabric',
  component: () => import('@/views/printFabric/index.vue'),
  children: [
    {
      path: '',
      name: 'PrintFabricLabel',
      component: () => import('@/views/printFabric/pages/PrintFabric.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'area_manager',
          'developer',
          'support',
          'warehouse_manager',
          'warehouse',
          'store_manager',
          'accounting_manager',
          'acting_assist_store_manager',
          'assist_store_manager',
          'sales_staff'
        ]
      }
    }
  ]
}
